export const actionTypes = {
    FETCH_MY_MAPS_TILE_LAYER_DICTIONARY: 'MY_MAPS/SELECTION/FETCH_TILE_LAYER_DICTIONARY',
    FETCH_MY_MAPS_TILE_LAYER_DICTIONARY_LOADING: 'MY_MAPS/SELECTION/FETCH_TILE_LAYER_DICTIONARY_LOADING',
    FETCH_MY_MAPS_TILE_LAYER_DICTIONARY_SUCCESS: 'MY_MAPS/SELECTION/FETCH_TILE_LAYER_DICTIONARY_SUCCESS',

    SET_MY_MAPS_VISIBLE_TILE_LAYER_GROUPS: 'MY_MAPS/SELECTION/SET_VISIBLE_TILE_LAYER_DICTIONARIES',
    SET_MY_MAPS_HIGHLIGHTED_TILE_LAYER_GROUP: 'MY_MAPS/SELECTION/SET_HIGHLIGHTED_TILE_LAYER_DICTIONARY',
    SET_MY_MAPS_HIGHLIGHTED_TILE_LAYER_ID: 'MY_MAPS/SELECTION/SET_HIGHLIGHTED_TILE_LAYER_ID',
};
